<template>
  <el-select :disabled="disabled" :multiple='multiple' clearable @change="handleChange" :value="data.value" :placeholder="$t('请选择')" @clear="handleChange()" filterable>
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in sitePoint" :key="index"></el-option>
  </el-select>
</template>

<script>
  import {getCascade} from '@/services/customer'

  export default {
    name: 'SitePoint',
      props: {
          value: {},
          operator:{},
          disabled: {
              type: Boolean,
              default: false
          },
          multiple:{
            type: Boolean,
              default: false
          }
      },
    data() {
      return {data: {}, sitePoint: []}
    },
    mounted() {
      this.loadData();
    },
    watch: {
      operator: {
         immediate:true,
          handler(value){
             if(value){
                 this.loadData(value)
             }else{
                 this.sitePoint =[];
             }
          },
      },
        value:{
            immediate:true,
            handler(value){
                if (value) {
                    this.data = value;
                } else {
                    this.data = {};
                }

            }
        }
    },
    methods: {
      handleChange(value) {

        let find = this.sitePoint.find((item, i) => {
          return item.value == value
        });
        if (find == undefined) {
          find = {};
        }
        this.$emit("input", find)
        this.$emit("change", find)
        this.data = find;
      },
      async loadData(operator) {
        this.sitePoint = [];
        this.data = {};
        this.$emit("input", {})
        if (operator) {
            const response = await getCascade({factoryIds:operator.value});
            console.log(response,"sds")
            if (response && response.data.clientList) {
            this.sitePoint = response.data.clientList.map((item, i) => {
              return {name: item.clientName, value: item.clientId}                          
            })
            //  console.log(this.sitePoint);
            //  this.$emit('getson', this.sitePoint)
          }

        }
      }

    }

  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/operation/SitePoint.vue